import { inject } from 'aurelia-framework';
import { EventAggregator } from 'aurelia-event-aggregator';
import { CoatingService } from 'pages/system-fields/coatings/service';
import { DialogService } from 'aurelia-dialog';
import { formatTableLink, creatTableButton } from 'resources/utility';
import toastr from 'toastr';

@inject(CoatingService, DialogService, EventAggregator)
export class Coatings {
    constructor(coatingService, dialogService, ea) {
        this.ea = ea;
        this.coatingService = coatingService;
        this.dialogService = dialogService;

        this.columns = [
            { dataField: 'name', sortOrder: 'asc', cellTemplate: (container, options) => formatTableLink({ container, containerOptions: options, callback: this.edit }) },
            { caption: 'Actions', cellTemplate: (container, options) => creatTableButton({ container, containerOptions: options, style: 'danger', label: 'Delete', action: this.delete }), allowExporting: false }
        ];

        this.subscription = this.ea.subscribe('coatings:updated', () => {
            this.grid.refresh();
        });
    }

    deactivate () {
        this.subscription.dispose();
    }

    delete = (coating) => {
        this.dialogService.open({ viewModel: PLATFORM.moduleName('resources/elements/modals/confirm/index') }).whenClosed(async response => {
            if (!response.wasCancelled) {
                await this.coatingService.delete(coating.id);
                this.grid.refresh();
                toastr.success('Coating was deleted!');
            }
        });
    };

    add() {
        this.dialogService.open({ viewModel: this.coatingService.editor });
    }

    edit = (data) => {
        this.dialogService.open({ viewModel: this.coatingService.editor, model: { id: data.id } });
    };
}